import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import {
  countryInputValueSelector,
  openAddRecordModalSelector,
  sampleCountInputValueSelector,
  setCountryInputValue,
  setOpenAddRecordModal,
  setSampleCountInputValue,
} from '../../../store/slices/adminSlice';
import { Input, LoadingOverlay, Modal, NumberInput } from '@mantine/core';
import WFIDButton from '../../WFIDButton/WFIDButton';

import genusTableController from '../../../controllers/genusTableController';
import { NotificationType, showNotification } from '../../../utils/showNotifications';
import './index.css';

const AddRecordModal = () => {
  const openAddRecordModal = useSelector(openAddRecordModalSelector);
  const countryInputValue = useSelector(countryInputValueSelector);
  const sampleCountInputValue = useSelector(sampleCountInputValueSelector);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(setOpenAddRecordModal(false));
  };
  const handleCreateRecord = async () => {
    setLoading(true);
    const attributes = {
      Country_Name: countryInputValue,
      Sample_Count: sampleCountInputValue,
    };

    try {
      const response = await genusTableController.addFeatureData({
        layer: genusTableController.getGenusSampleFeatureLayer(),
        features: [{ attributes }],
      });

      if (!response.success) {
        showNotification({
          type: NotificationType.Error,
          message: 'Error adding record',
          title: 'Error',
        });
        setLoading(false);
        return;
      }
      showNotification({
        type: NotificationType.Success,
        message: 'Record added successfully',
        title: 'Success',
      });
      setLoading(false);
      dispatch(setCountryInputValue(''));
      dispatch(setSampleCountInputValue(''));
      handleCloseModal();
      genusTableController.refreshTable();
    } catch (err) {
      setLoading(false);
      console.log('err', err);
    }
  };
  const handleCountryChange = (event: any) => {
    const value = event.currentTarget.value;
    dispatch(setCountryInputValue(value));
  };

  const handleSampleCountChange = (value: number | string | undefined) => {
    dispatch(setSampleCountInputValue(value));
  };
  return (
    <div>
      <Modal closeOnClickOutside={false} zIndex={2000} opened={openAddRecordModal} onClose={handleCloseModal} title=''>
        <LoadingOverlay zIndex={1000} visible={loading} overlayProps={{ radius: 'sm', blur: 2 }} />
        <section className='modalContent'>
          <div className='input-field-container'>
            <Input.Wrapper label='Enter Country Name'>
              <Input value={countryInputValue} onChange={handleCountryChange} placeholder='Country Name' />
            </Input.Wrapper>
          </div>
          <div className='input-field-container'>
            <NumberInput
              hideControls
              value={sampleCountInputValue}
              onChange={handleSampleCountChange}
              label='Enter Sample Count'
              placeholder='Sample Count'
            />
          </div>

          <div className='button-container'>
            <WFIDButton
              disabled={!sampleCountInputValue || !countryInputValue}
              bgColor='white'
              content='Add Record'
              onClick={handleCreateRecord}
            />
          </div>
        </section>
      </Modal>
    </div>
  );
};

export default AddRecordModal;
